<app-template-preview [control]="control" [value]="value" (preview)="setImage($event)" [type]="type">{{ "FORM.THREATS.BOOL.IM2" }}</app-template-preview>
